import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";

export const Hero = () => {
  const navigate = useNavigate();
  const images = [
    "https://thumbs-us-east-1.myalbum.io/photo/1k0/a9e6a600-0961-425c-b4a5-47eae42abdb0.jpg",
    "https://thumbs-us-east-1.myalbum.io/photo/1k0/3a1535b1-2530-4427-ac83-7834c99cbf77.jpg",
    "https://thumbs-us-east-1.myalbum.io/photo/1k0/18995c20-75cb-418a-856b-14070a79cb84.jpg",
    "https://thumbs-us-east-1.myalbum.io/photo/1k0/f04def12-f86c-4b75-be40-c0aaaeeac516.jpg",
    "https://thumbs-us-east-1.myalbum.io/photo/1k0/c77b787c-ff74-45b6-bb2e-fdde6ca81518.jpg",
    "https://thumbs-us-east-1.myalbum.io/photo/1k0/75012555-53c5-4063-8334-5ac30a4c8216.jpg",
    "https://thumbs-us-east-1.myalbum.io/photo/1k0/2158a4df-f907-40e5-b7be-b949dea07405.jpg",
    "https://thumbs-us-east-1.myalbum.io/photo/1k0/8a434a5e-bb97-4742-90c5-04a5eb121821.jpg",
    "https://thumbs-us-east-1.myalbum.io/photo/1k0/e3a986cc-830d-474c-9f4f-226f8110e6cf.jpg",
    "https://thumbs-us-east-1.myalbum.io/photo/1k0/f1f9df3d-20b5-46fa-959f-6d0bc88eacb6.jpg",
    "https://thumbs-us-east-1.myalbum.io/photo/1k0/cdb4a571-76e8-48a6-ab70-03eab0beaab4.jpg",
  ];

  const [index, setIndex] = useState(0);
  const [prevIndex, setPrevIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setPrevIndex((prev) => {
        const next = (index + 1) % images.length;
        return index;
      });

      setIndex((prev) => (prev + 1) % images.length);
    }, 6000);

    return () => clearInterval(interval);
  }, [index]);

  return (
    <section className="hero-section">

      {/* IMAGEN ANTERIOR */}
      <div
        className="hero-bg fade-out"
        style={{ backgroundImage: `url(${images[prevIndex]})` }}
      />

      {/* IMAGEN ACTUAL */}
      <div
        className="hero-bg fade-in"
        style={{ backgroundImage: `url(${images[index]})` }}
      />

      {/* 🔥 OVERLAY SUAVE */}
      <div className="hero-overlay" />

      {/* CONTENIDO */}
      <div className="hero-content">
        <h1 className="hero-title">Teen Missions Perú</h1>
        <h3 className="hero-subtitle">
          Levantando a una generación para servir a Cristo
        </h3>

        <button
          type="button"
          className="btn btn-outline-modern mt-4 btn-participar"
          onClick={() => navigate("/bootcamp/registro")}
        >
          PARTICIPA
        </button>
      </div>

    </section>
  );
};